import { TextualChannel } from 'lib-shared-types-channels';

import { WebformEndpoint } from 'apis/webformEndpoints';

/** Represents the custom form object as defined on the client side */
export type CustomForm = {
  id: string;
  title: string;
  submitButtonLabel: string;
  feedbackAfterSubmit: string;
  fields: CustomFormField[];
  usage: FormUsage[];
  hasAttributes: boolean;
};

/** Represents the flows in which the form is used in */
export type FormUsage = {
  flowId: string;
  flowTitle: string;
  flowChannel: CustomFormFlowChannel;
};

/** Represents the channels for which the form can be used to be build a flow */
export type CustomFormFlowChannel = TextualChannel;

/** Represents the definition of a form field on a custom form */
export type CustomFormField = {
  type: CustomFormFieldType;
  id: string;
  title: string;
  placeholder?: string;
  required: boolean;
  options?: CustomFormFieldOption[];
};

export type CustomFormFieldType =
  | 'text'
  | 'textarea'
  | 'select'
  | 'attachments'
  | 'email'
  | 'name'
  | 'subject';

export type CustomFormFieldOption = {
  value: string;
};

/** Represents the input needed to create a new custom form */
export type CreateNewCustomFormInput = {
  label: string;
  description: string;
  submitButtonLabel: string;
  submitSuccessMessage: string;
};

export type FormSubmissionData = {
  /** The id of the form that was submitted */
  formId: string;
  /**
   * Version of the form. Combination of the form ID and version creates a
   * unique reference to a submitted form
   */
  formVersion: string;
  /** The id of the submission */
  submissionId: string;
  /** The submitted values */
  submissionData: Record<FieldId, FieldSubmission>;
};

type FieldId = string;

// make a discriminated union type from the keys of FieldDataTypeToValueMap
export type FieldSubmission =
  | StringFieldValue
  | StringArrayFieldValue
  | FilesFieldValue;

type StringFieldValue = { type: 'string'; value: string };
type StringArrayFieldValue = { type: 'stringArray'; value: string[] };
type FilesFieldValue = { type: 'fileArray'; value: FileFieldValue[] };

/** Represents the value of file inputs in the form */
export type FileFieldValue = {
  /** File URL relative to the org url */
  relative_url: string;
  /** File name */
  name: string;
  /** MIME type, e.g. 'image/jpeg' */
  media_type: string;
  /** File size in bytes */
  bytes_length: number;
};

/** Constant used to distinguish a user's name field from other text fields */
export const externalReferenceName = 'name';
/** Constant used to distinguish a user's email field from other text fields */
export const externalReferenceFromEmail = 'from_email';
/**
 * Constant used to distinguish the contact form subject field from other text
 * fields
 */
export const externalReferenceSubject = 'subject';

export type MessengerInfo = {
  messengerName: string;
  messengerId: string;
};

export type EndpointMessengers = {
  endpoint: WebformEndpoint;
  messengersInfo: MessengerInfo[];
};
